<template>
  <!--
    作者：kmdshop
    时间：2023-01-01
    描述：插件中心-股东分红
  -->
  <div>
    
    <!--商品设置-->
    <Product v-if="activeName == 'product'"></Product>
    <!--设置-->
    <Release v-if="activeName == 'release'"></Release>
    <!--设置-->
    <Setting v-if="activeName == 'setting'"></Setting>

  </div>
</template>
<script>
import bus from '@/utils/eventBus.js';
import Product from './product/index';
import Setting from './setting/index';
import Release from './product/release';

export default {
  components: {
    Product,
    Setting,
    Release
  },
  data() {
    return {
      /*参数*/
      param: {},
      /*当前选中*/
      activeName: 'product',
      /*切换数组原始数据*/
      sourceList: [
        {
          key: 'product',
          value: '产品设置',
          path:'/plus/pointsrelease/product/index'
        },
        {
          key: 'release',
          value: '活动记录',
          path:'/plus/pointsrelease/product/release'
        },
        {
          key: 'setting',
          value: '设置',
          path:'/plus/pointsrelease/setting/index'
        }
      ],
      /*权限筛选后的数据*/
      tabList:[],
    };
  },
  created() {

    this.tabList=this.authFilter();

    if(this.tabList.length>0){
      this.activeName=this.tabList[0].key;
    }

    if (this.$route.query.type != null) {
      this.activeName = this.$route.query.type;
    }

    /*监听传插件的值*/
    bus.$on('activeValue', res => {
      this.activeName = res;
    });

    //发送类别切换
    let params = {
      active: this.activeName,
      list: this.tabList,
      tab_type: 'bonus'
    };
    bus.$emit('tabData', params);
  },
  beforeDestroy() {
    //发送类别切换
    bus.$emit('tabData', { active: null, tab_type: 'bonus', list: [] });
    bus.$off('activeValue');
  },
  methods: {

    /*权限过滤*/
    authFilter(){
      let list=[];
      for(let i=0;i<this.sourceList.length;i++){
        let item=this.sourceList[i];
        if(this.$filter.isAuth(item.path)){
          list.push(item);
        }
      }
      return list;
    },

  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/pointsrelease/index.vue